/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    overflow: "hidden",
    position: "relative",
    margin: theme.spacing(2, 2, 0, 2),
    background: 'transparent !important',
  },
  textInputSignIn: {
    maxWidth: '32%',
  },
  cardRoot: {  },
  modalFormContent: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-4'],
    marginLeft: Tokens.spacing['$sp-4']
  },
  appBarWrap: {
    display: "flex",
    flexDirection: "row",
    background: 'transparent !important',
  },
  countrySelectArrow: {
    fontSize: Tokens.spacing['$sp-4'],
    marginLeft: Tokens.spacing['$sp-2']
  },
  textInput: {
    width: '100%',
    marginRight: Tokens.spacing['$sp-4'],
    marginTop: Tokens.spacing['$sp-3'],
    // maxWidth: Tokens.spacing['$sp-10'],
  },
  blockSignInCheckBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-4'],
  },
  footerActionsWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  userDetailWrap: {
    overflow: "scroll",
    flexDirection: "row",
    paddingTop: Tokens.spacing['$sp-4'],
    marginTop: Tokens.spacing['$sp-0-75'],
    borderRadius: Tokens.spacing['$sp-1'],
  },
  userDetailRightWrap: {
    flex: 8,
    overflow: "scroll",
    marginLeft: Tokens.spacing['$sp-6'],
    paddingLeft: Tokens.spacing['$sp-2'],
    paddingTop: Tokens.spacing['$sp-4'],
    paddingBottom: Tokens.spacing['$sp-10']
  },
  userDetailRolesWrap: {
    marginTop: Tokens.spacing['$sp-4'],
    marginLeft: Tokens.spacing['$sp-6'],
    paddingTop: Tokens.spacing['$sp-4'],
    paddingLeft: Tokens.spacing['$sp-6'],
    paddingBottom: Tokens.spacing['$sp-10'],
    backgroundColor: theme.palette.common.white,
  },
  dropDownText: {
    marginBottom: Tokens.spacing['$sp-2'],
    '& #dropdown-inputlabel-IDPDropdown': {
      fontSize: Tokens.spacing['$sp-4-5']
    },
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    color: theme.palette.common.white,
    '& .MuiCircularProgress-colorPrimary': {
      color: theme.palette.common.white
    },
    padding: Tokens.spacing['$sp-3']
  },
  subjectIdWrap: {
    width: "100%",
    marginTop: Tokens.spacing['$sp-6'],
  },
  tabHeader: {
    fontSize: Tokens.spacing['$sp-4-5'],
  },
  backIcon: {
    height: Tokens.spacing['$sp-12'],
    width: Tokens.spacing['$sp-12'],
    color: theme.palette.text.primary
  },
  userDetailsTabsWrap: {
    width: Tokens.spacing['$sp-37-5'],
  },
  headingAlignment: {
    color: theme.palette.text.primary,
    fontSize: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-4']
  },
  heading: {
    color: theme.palette.text.secondary
  },
  userNameInputContent: {
    width: `${5 * 8}%`
  },
  userNameInput: {
    marginTop: Tokens.spacing['$sp-8-5'],
    "&.MuiInput-input": {
      marginTop: Tokens.spacing['$sp-8-5']
    }
  },
  contentContainer: {
    marginTop: Tokens.spacing['$sp-6'],
  },
  passwordContainer: {
    marginTop: Tokens.spacing['$sp-6'],
    display: 'flex',
    alignItems: 'flex-start'
  },
  rolesContainer: {
    paddingTop: Tokens.spacing['$sp-10'],
  },
  tabs: {
    borderBottomColor: theme.palette.divider,
    borderBottomStyle: 'solid',
    borderBottomWidth: 'thin'
  },
  tab: {
    borderBottom: 'none !important',
    color: `${theme.palette.text.primary}  !important`,
    "&.Mui-selected span": {
      color: `${theme.palette.primary.main}  !important`,
    },
    "& .Mui-selected span": {
      color: `${theme.palette.primary.main}  !important`,
    }
  },
  tabpanel: {
    padding: 0
  },
  tabSection: {
    paddingLeft: Tokens.spacing['$sp-10']
  },
  tabGeneralSection: {
    padding: 0,
  },
  mfaWrap: {
    paddingLeft: Tokens.spacing['$sp-4'],
    marginRight: Tokens.spacing['$sp-4'],
  },
  gridViewWrap: {
    paddingRight: Tokens.spacing['$sp-2']
  },
  nativeUserContainer: {
    padding: 0,
    "& header": {
      padding: 0,
      margin: 0
    },
  },
  divider: {
    marginTop: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-6'],
    marginRight: Tokens.spacing['$sp-4']
  },
  toolsBar: {
    display: "flex",
    justifyContent: 'flex-end',
    background: theme.palette.grey[50],
    paddingRight: Tokens.spacing['$sp-2'],
    paddingLeft: Tokens.spacing['$sp-2'],
    paddingBottom: Tokens.spacing['$sp-0-5'],
    paddingTop: Tokens.spacing['$sp-0-5'],
    alignItems: 'center',
    minHeight: Tokens.spacing['$sp-12']
  },
  toolBarButton: {
    position: 'absolute',
    top: Tokens.spacing['$sp-26'],
    right: Tokens.spacing['$sp-8-5']
  },
  rightToolBarButton: {
    position: 'absolute',
    top: Tokens.spacing['$sp-26'],
    right: Tokens.spacing['$sp-46'],
  },
  serverErrorMessage: {
    width: '97%',
    position: 'absolute',
  },
  modalTextBoxPhone: {
    marginTop: Tokens.spacing['$sp-3'],
    paddingRight: Tokens.spacing['$sp-2-5'],
    width: "100%",
    '&.PhoneInput .PhoneInputCountrySelectArrow': {
      marginLeft: Tokens.spacing['$sp-4']
    },
    '&.PhoneInput .PhoneInputInput': {
      marginLeft: Tokens.spacing['$sp-2']
    },
    '&.PhoneInput .PhoneInputInput, &.PhoneInput .PhoneInputCountry': {
      border: 'none',
      outline: 'none',
      paddingBottom: Tokens.spacing['$sp-2'],
      paddingTop: Tokens.spacing['$sp-2'],
      marginBottom: Tokens.spacing['$sp-0-25'],
      borderBottom: `1px solid ${theme.palette.secondary.light}`,
      background: 'transparent',
      color: theme.palette.text.primary
    },
    '&.PhoneInput .PhoneInputInput:hover, &.PhoneInput .PhoneInputCountry:hover': {
      border: 'none',
      outline: 'none',
      marginBottom: Tokens.spacing['$sp-0'],
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
    },
    '&.PhoneInput.PhoneInput--focus .PhoneInputInput, &.PhoneInput.PhoneInput--focus .PhoneInputCountry': {
      border: 'none',
      outline: 'none',
      marginBottom: Tokens.spacing['$sp-0'],
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    }
  },
  modalTextBoxPhoneError: {
    '&.PhoneInput .PhoneInputInput, &.PhoneInput .PhoneInputCountry ': {
      borderBottom: `1px solid ${theme.palette.error.main}`,
    },
    '&.PhoneInput .PhoneInputInput:hover, &.PhoneInput .PhoneInputCountry:hover': {
      borderBottom: `2px solid ${theme.palette.error.main}`,
    },
    '&.PhoneInput.PhoneInput--focus .PhoneInputInput, &.PhoneInput.PhoneInput--focus .PhoneInputCountry': {
      borderBottom: `2px solid ${theme.palette.error.main}`,
    },
  },
  mobilePhoneError: {
    marginLeft: Tokens.spacing['$sp-4']
  },
  contactDetailsWrap: {
   
  },
  iconBox: {
    float: 'right',
    marginTop: Tokens.spacing['$sp-3'],
  },
  iconAlignment: {
    cursor: "pointer",
  },
  policyText: {
    paddingLeft: Tokens.spacing['$sp-2']
  },
  checkBoxWrap: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-2']
  },
  checkBoxHeading: {
    fontWeight: 700,
  },
  contentContainerDisplayName: {
    marginTop: Tokens.spacing['$sp-6']
  },
  contentContainerMFA: {
    marginTop: Tokens.spacing['$sp-6'], 
    marginLeft: Tokens.spacing['$sp-25'],
  }
}));
